// ⚠️ SYNC : ce fichier est dupliqué dans
//   api/src/contracts/cancellation-reasons.ts
// Toute modification ici doit être répercutée côté backend.

export const CANCELLATION_REASON_CODES = [
  'input_error',
  'client_withdrawal',
  'other_warranty',
  'other',
  'admin_direct',
  'payment_link_expired',
  'payment_unpaid',
  'dispute_lost',
  'partner_api',
  'upsell_replacement',
  'upsell_retraction',
  'subscription_ended_externally',
] as const;

export type CancellationReasonCode = typeof CANCELLATION_REASON_CODES[number];

export const CANCELLATION_REASON_LABELS: Record<CancellationReasonCode, string> = {
  input_error: 'Erreur de saisie',
  client_withdrawal: 'Désistement client',
  other_warranty: 'Autre garantie souhaitée par le client',
  other: 'Autre',
  admin_direct: 'Annulation administrative',
  payment_link_expired: 'Lien de paiement expiré',
  payment_unpaid: 'Impayés — prélèvements en échec',
  dispute_lost: 'Opposition au paiement',
  partner_api: 'Annulation via API partenaire',
  upsell_replacement: 'Remplacé par un nouveau contrat (upsell)',
  upsell_retraction: 'Rétractation du lead upsell',
  subscription_ended_externally: 'Souscription Stripe annulée hors plateforme',
};

export function getCancellationReasonLabel(code?: string | null): string | null {
  if (!code) return null;
  return CANCELLATION_REASON_LABELS[code as CancellationReasonCode] ?? code;
}

// Sous-ensemble proposé dans le modal de demande utilisateur (RequestCancellationModal)
export const USER_CANCELLATION_REASONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'input_error', label: CANCELLATION_REASON_LABELS.input_error },
  { value: 'client_withdrawal', label: CANCELLATION_REASON_LABELS.client_withdrawal },
  { value: 'other_warranty', label: CANCELLATION_REASON_LABELS.other_warranty },
  { value: 'other', label: CANCELLATION_REASON_LABELS.other },
];
